interface StoreCardSkeletonProps {
  variant: 'pickup' | 'delivery'
  index: number
}

export function StoreCardSkeleton({ variant, index }: StoreCardSkeletonProps) {
  return (
    <div 
      className="w-full rounded-2xl bg-surface-elevated border border-border-light shadow-card overflow-hidden animate-fade-in"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="flex flex-col @md:flex-row">
        <div className="relative @md:w-56 @md:shrink-0 h-48 @md:h-auto @md:min-h-[200px] bg-surface-tertiary animate-shimmer" />
        <div className="flex-1 p-5 @md:py-5 @md:px-6">
          <SkeletonContent variant={variant} />
        </div>
      </div>
    </div>
  )
}

function SkeletonContent({ variant }: { variant: 'pickup' | 'delivery' }) {
  return (
    <>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1">
          <div className="h-6 w-2/3 rounded-md bg-surface-tertiary animate-shimmer" />
          <div className="h-4 w-1/3 rounded-md bg-surface-tertiary animate-shimmer mt-2.5" />
        </div>
        <div className="h-6 w-16 rounded-full bg-surface-tertiary animate-shimmer shrink-0" />
      </div>
      
      <div className="h-4 w-3/4 rounded-md bg-surface-tertiary animate-shimmer mb-4" />
      
      <div className="flex items-center gap-3">
        <div className="h-7 w-20 rounded-full bg-surface-tertiary animate-shimmer" />
        <div className="h-7 w-24 rounded-full bg-surface-tertiary animate-shimmer" />
        {variant === 'delivery' && (
          <div className="h-7 w-20 rounded-full bg-surface-tertiary animate-shimmer" />
        )}
      </div>
    </>
  )
}
